<div *ngIf="columns && columnsSettings && size && mode" 
     [ngStyle]="{'width': workingWidthUsedWidth+'px'}">
    <!--DEBUG ONLY-->
    <div *ngIf="formFieldDataService.DEBUG_MODE" style="border: 1px solid red;">
        <app-json-viewer [datasource]="{selectedRowId: selectedRowId}"></app-json-viewer>
        <app-json-viewer [datasource]="{checkedRowsIds: checkedRowsIds}"></app-json-viewer>
    </div>
    <!--
    FILTERS HEADER
    -->
    <div class="filters-header layout horizontal space-between middle">
        <div class="layout horizontal left middle" 
            (click)="filtersShown=!filtersShown" 
            style="cursor: pointer; width: 260px;">
            <div class="horizontal layout center middle" style="height: 40px; width: 40px;">
                <mat-icon class="mat-icon-rtl-mirror">
                    {{filtersShown ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}
                </mat-icon>
            </div>
            <span>{{'GRID.FILTERS'|translate}}</span>
            <div class="layout horizontal center middle" style="height: 24px; width: 24px; margin-inline-start: 2px;">
                <mat-icon>filter_list</mat-icon>
            </div>
            <div *ngIf="activeFiltersCounter>0" style="margin-inline-start: 10px;">
                <span style="margin: 0 2px;">(</span>
                <span>{{activeFiltersCounter==1?('GRID.1_CRITERION'|translate):('GRID.N_CRITERIA'|translate:{number:activeFiltersCounter})}}</span>
                <span style="margin: 0 2px;">)</span>
            </div>
        </div>
        <div class="layout horizontal right middle">
            <ng-container>
                <button mat-icon-button [disabled]="filtering || activeFiltersCounter==0" (click)="clearFilters()">
                    <mat-icon>clear</mat-icon>
                </button>
                <button mat-icon-button [disabled]="filtering" (click)="refresh()">
                    <mat-icon [svgIcon]="!error ? 'reload' : 'reload-alert'"></mat-icon>
                </button>
                <!--Scommentare quando sarà stata implementata almeno una funzionalità aggiuntiva sulla grid-->
                <button mat-icon-button [disabled]="filtering" [matMenuTriggerFor]="gridMenu">
                    <mat-icon>more_vert</mat-icon>
                </button>
            </ng-container>
            <mat-menu #gridMenu="matMenu">
                <ng-container *ngFor="let action of availableActions">
                    <button mat-menu-item *ngIf="(action.requiredAuthorities||[]) | ownedByPrincipal"
                            (click)="setCurrentAction(action)">
                        <mat-icon [svgIcon]="action.icon"></mat-icon>
                        <span>{{action.label}}</span>
                    </button>
                    <!-- <mat-divider></mat-divider> -->
                    <!-- <button mat-menu-item [disabled]="!filtersModified"
                            (click)="resetFilters()">
                        <mat-icon>settings_backup_restore</mat-icon>
                        <span>Reset</span>
                    </button> -->
                </ng-container>
            </mat-menu>
            <!-- <div *ngIf="filtering" class="layout horizontal center middle" style="height: 40px; width: 40px;">
                <mat-spinner diameter="20"></mat-spinner>
            </div> -->
        </div>
    </div>
    <!--
    H-SCROLLABLE SECTION
    -->
    <div id="h-scrollable-area-container"
         style="overflow: auto; white-space: nowrap;">
        <div id="h-scrollable-area" 
             [ngStyle]="{'width': width+'px'}">
            <!--
            FILTER SET
            -->
            <div [style.visibility]="!filtersShown? 'hidden': 'visible'" 
                 class="layout horizontal left top" 
                 style="width: 100%;"
                 [ngStyle]="{'height': filtersShown?'inherit': '0'}"
                 *ngIf="filterValuesForInput">
                <ng-container *ngFor="let columnId of Object.keys(columns)">
                    <!-- PLACEHOLDER PER COLONNA SELEZIONE MULTIPLA -->
                    <div *ngIf="columnId=='selection' && selectionColumnShown"
                         style="width: 40px;">
                    </div>
                    <ng-container *ngIf="columnId!='selection' && !columns[columnId].hidden">
                        <!--questo layout serve solo in caso di DEBUG attivo per incolonnare il log sotto il campo di filtro-->
                        <div class="layout vertical top left">
                            <!-- PLACEHOLDER PER CAMPI NON FILTRABILI -->
                            <div *ngIf="!columns[columnId].filterable" 
                                style="height: 51.6px; border-radius: 4px; border: 1px solid #e5e5e5; background-color: #f8f8f8; margin-top: 3.6px;"
                                [ngStyle]="{'width': columns[columnId].width}"></div>
                            <!-- FILTERS -->
                            <app-filter-field *ngIf="columns[columnId].filterable"
                                        [type]="columns[columnId].type == 'BOOLEAN' ? 'OPTION' : columns[columnId].type"
                                        [value]="filterValuesForInput[columnId]"
                                        [equalLabel]="''"
                                        [fromLabel]="'from'" 
                                        [toLabel]="'to'"
                                        [width]="columns[columnId].width"
                                        [settings]=columnsSettings[columnId]
                                        (modelChange)="updateCurrentFilterState(columnId,$event)">
                            </app-filter-field>
                            <!--DEBUG ONLY-->
                            <div *ngIf="formFieldDataService.DEBUG_MODE" style="border: 1px solid red;">
                                <ng-container *ngIf="formFieldDataService.DEBUG_MODE"><pre>{{_currentFilterCriteria[columnId]|json}}</pre></ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <!--  //Attributi che al momento si è deciso di settare diversamente
                    [equalLabel]="columns[columnId].label+' (contains)'"
                    [fromLabel]="columns[columnId].label+' (from)'" 
                    [toLabel]="columns[columnId].label+' (to)'"
                    -->
                </ng-container>
            </div>
            <!--
            GRID HEADER
            -->
            <div class="grid-header layout horizontal left middle" style="width: 100%; height: 40px;">
                <ng-container *ngFor="let columnId of Object.keys(columns)">
                    <!--
                    GRID HEADER - COLONNA SPECIALE SELEZIONE MULTIPLA
                    -->
                    <div *ngIf="columnId == 'selection' && selectionColumnShown"
                         class="layout horizontal center middle"
                         style="width: 40px; height: 40px;">
                        <mat-checkbox *ngIf="rowCount<=serverSideGridMaxRowNum" [checked]="checkableRowsIdsForCurrentAction.length==checkedRowsIds.length"
                                      [indeterminate]="checkedRowsIds.length>0 && checkableRowsIdsForCurrentAction.length!=checkedRowsIds.length"
                                      (change)="toggleGlobalCheck($event.checked)">
                        </mat-checkbox>
                        <app-icon *ngIf="rowCount>serverSideGridMaxRowNum" id="information-outline" clickable="true"></app-icon>    
                    </div>
                    <!--
                    GRID HEADER - COLONNE NORMALI
                    -->
                    <ng-container *ngIf="columnId != 'selection'">
                        <div *ngIf="!columns[columnId].hidden"
                            class="grid-column-header"
                            [ngClass]="{'sortable': columns[columnId].sortable}"
                            [ngStyle]="{'cursor': columns[columnId].sortable?'pointer':null,
                                        'width': columns[columnId].width,
                                        'min-width': columns[columnId].width}"
                            (click)="changeSort(columnId)"
                            [align]="['NUMBER','INTEGER','AMOUNT','YEAR'].includes(columns[columnId].type) || columns[columnId].aggregate ? 'right' : 'left'">
                            <ng-container *ngIf="!['NUMBER','INTEGER','AMOUNT','YEAR'].includes(columns[columnId].type) && !columns[columnId].aggregate">
                                {{columns[columnId].label|translate}}
                                <sort-arrow #sortArrow
                                            [class]="(sortCriterion && sortCriterion.columnId==columnId) ? sortCriterion.direction : null">
                                </sort-arrow>
                                <!-- <mat-spinner diameter="18"></mat-spinner> -->
                            </ng-container>
                            <ng-container *ngIf="['NUMBER','INTEGER','AMOUNT','YEAR'].includes(columns[columnId].type) || columns[columnId].aggregate">
                                <sort-arrow #sortArrow
                                            [class]="(sortCriterion && sortCriterion.columnId==columnId) ? sortCriterion.direction : null">
                                </sort-arrow>
                                {{columns[columnId].label|translate}}
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
            </div>
            <!--
            GRID BODY
            -->
            <cdk-virtual-scroll-viewport *ngIf="rowsShown"
                                         class="grid-rows-viewport"
                                         itemSize="50"
                                         [ngStyle]="{'height': (size*50)+'px'}">
                <div *cdkVirtualFor="let row of shownRows; 
                                     let even = even;
                                     let odd = odd;
                                     templateCacheSize: 0" 
                     class="grid-row"
                     [class.grid-row-alternate]="odd">
                    <!--
                    GRID ROW
                    -->
                    <div class="grid-row layout horizontal left middle" 
                         style="width: 100%;"
                         (click)="rowClick(row)"
                         [ngClass]="{'selected': selectedRowId==row.id,
                                     'checked': checkedRowsIds.includes(row.id)}">
                        <!--
                        GRID ROW CELL
                        -->
                        <ng-container *ngFor="let columnId of Object.keys(columns)">
                            <!--
                            CELLA SPECIALE SELEZIONE MULTIPLA
                            -->
                            <div *ngIf="selectionColumnShown && columnId == 'selection'"
                                    class="layout horizontal center middle"
                                    style="width: 40px; height: 40px;"
                                    (click)="eventStopper($event)">
                                <mat-checkbox [checked]="checkedRowsIds.includes(row.id)"
                                              [disabled]="currentAction != 'none' ? !actionsPreconditions[row.id][currentAction.id] : true"
                                              (change)="modifyCheckedRowsIds(row.id, $event.checked)">
                                </mat-checkbox>
                            </div>
                            <!--
                            CELLA NORMALE
                            -->
                            <ng-container *ngIf="columnId != 'selection'">
                                <div *ngIf="!columns[columnId].hidden"
                                     class="grid-cell"
                                     [ngStyle]="{'width': columns[columnId].width,
                                                 'min-width': columns[columnId].width}">
                                    <app-form-field *ngIf="columns && columnsSettings && row"
                                                    mode="grid"
                                                    [width]="columns[columnId].width"
                                                    [type]="columns[columnId].type"
                                                    [aggregate]="columns[columnId].aggregate"
                                                    [value]="row[columnId]"
                                                    [readOnly]="true"
                                                    [settings]="columnsSettings[columnId]">
                                    </app-form-field>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </cdk-virtual-scroll-viewport>
            <!--VIEWPORT PLACEHOLDER-->
            <div *ngIf="!rowsShown"
                 style="width: 100%;" 
                 [ngStyle]="{'height': (size*50)+'px'}">
                <div *ngFor="let mockRow of Array(size).fill(0); let i=index" 
                     class="grid-row"
                     [ngStyle]="{'background-color': i==searchingAnimationIndex?'rgba(0, 0, 0, 0.03)':null}">
                </div>
            </div>
        </div>
    </div>
    <!--
    GRID FOOTER
    -->
    <div class="grid-footer layout horizontal space-between top">
        <!--placeholder per mandare sul lato opposto il contatatore delle righe-->
        <div *ngIf="!selectionColumnShown && !loadingMoreItems"></div>
        <div *ngIf="selectionColumnShown">
            {{checkedRowsIds.length}}
            <span>{{checkedRowsIds.length==1 ? 'item ' : 'items '}}</span>
            <span>selected</span>
        </div>
        <div *ngIf="loadingMoreItems">
            <span>{{'GRID.LOADING_MORE_ITEMS'|translate}}</span>
        </div>
        <ng-container *ngIf="rowsShown">
            <div *ngIf="error">
                {{'GRID.ERROR_LOADING_ITEMS'|translate}}
            </div>
            <div *ngIf="!error">
                <span *ngIf="mode=='server'">
                    <span *ngIf="rowCount==0">{{('GRID.N_ITEMS_FOUND'|translate:{number:0})}}</span>
                    <span *ngIf="rowCount==1">{{'GRID.1_ITEM_FOUND'|translate}}</span>
                    <span *ngIf="rowCount>1 && rowCount<=1000">{{('GRID.N_ITEMS_FOUND'|translate:{number:rowCount})}}</span>
                    <span *ngIf="rowCount>1000">{{'GRID.MORE_THAN_N_ITEMS_FOUND'|translate}}</span>
                </span>
                <span *ngIf="mode=='client'">
                    <span *ngIf="!shownRows">{{('GRID.N_ITEMS_FOUND'|translate:{number:0})}}</span>
                    <span *ngIf="shownRows && shownRows.length==1">{{'GRID.1_ITEM_FOUND'|translate}}</span>
                    <span *ngIf="shownRows && shownRows.length>1">{{('GRID.N_ITEMS_FOUND'|translate:{number:shownRows.length})}}</span>
                </span>
            </div>
        </ng-container>
    </div>
</div>